import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, type ReactElement } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from '@/components/ui/Button';
import { Spinner } from '@/components/ui/Spinner';
import { env } from '@/lib/env';

export function Login(): ReactElement {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const returnTo = params.get('returnTo') ?? '/dashboard';
      void navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, navigate, params]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner label="Cargando…" />
      </div>
    );
  }

  return (
    <main className="flex h-screen flex-col items-center justify-center gap-4 bg-gray-50">
      <h1 className="text-2xl font-bold text-gray-900">{env.VITE_APP_NAME}</h1>
      <p className="text-sm text-gray-600">Inicia sesión con tu cuenta institucional</p>
      <Button
        onClick={() =>
          void loginWithRedirect({ appState: { returnTo: params.get('returnTo') ?? '/dashboard' } })
        }
      >
        Entrar con Auth0
      </Button>
    </main>
  );
}
